import { FormInput } from "../components/FormInput";
import styles from '../css/Contacto.module.scss';
import { TextArea } from "../components/TextArea";
import { Titulo } from "../components/Titulo";
import { ButtonDark } from "../components/ButtonDark";
import axios from "../axios";
import { handleError, toastError, toastSuccess } from "../functions";
import axiosRequest from "../axiosRequest";


export const Contacto = ({ }) => {
    const datosContacto = [
        { text: 'Nombre', key: 'name', type: 'text', className: 'col-5 offset-1', id: 'nombreInput' },
        { text: 'Apellido', key: 'surname', type: 'text', className: 'col-5', id: 'apellidoInput' },
        { text: 'Mail', key: 'email', type: 'email', className: 'col-5 offset-1', id: 'mailInput' },
        { text: 'Teléfono', key: 'phone', type: 'text', className: 'col-5', id: 'telefonoInput' },
        { text: 'Mensaje', key: 'message', type: 'textArea', className: 'col-10 offset-1', id: 'mensajeInput' }
    ]

    function procesarDatos() {
        let camposValidos = true;
        const body = {};

        datosContacto.forEach(({ id, key }) => {
            const input = document.getElementById(id);
            if (!input || !input.value.trim()) {
                camposValidos = false;
                input.classList.add('border-danger');
            } else {
                body[key] = input.value.trim();
            }
        });

        return { camposValidos, body };
    }

    function enviar() {
        const { camposValidos, body } = procesarDatos();
        if (!camposValidos) {
            toastError('Debe completar todos los campos');
            return;
        }
        axiosRequest.post("/send-email", body, true, "Enviando, aguarde un instante")
            .onResponse((response) => {
                toastSuccess('Consulta enviada');
                datosContacto.forEach(({ id }) => {
                    document.getElementById(id).value = '';
                });
            })
    }

    return (
        <>
            <div className={"container px-5 pb-5  " + styles.mainContacto}>
                <div className="text-center"><Titulo texto={'ENVIANOS TU CONSULTA'} subrayar={true} /></div>
                <div className="row mt-5">
                    {datosContacto.map((elem) => (
                        elem.type === 'textArea' ?
                            <TextArea text={elem.text} className={elem.className} id={elem.id} />
                            :
                            <FormInput text={elem.text} type={elem.type} className={elem.className} id={elem.id} />
                    ))}
                    <div className="col-11 text-end ">
                        <ButtonDark text={'Enviar consulta'} funcion={enviar} className={'px-5'} />
                    </div>
                </div>
            </div>
        </>
    )

}